import type { FetcherOptions } from "@/modules/fetch/types"

import { generateClientHeaders } from "./generateClientHeaders"

/**
 * If env is local, we need to force "include" for credentials field
 * so that cookie is added to cross-origin requests. "include" tells browsers to include cookies
 * in both same- and cross-origin requests, and always use any cookies sent back in responses.
 * Notice that "same-origin" is the default value.
 */
export const internalClientOptions = async (init: RequestInit, options: FetcherOptions): Promise<RequestInit> => {
  const defaultOptions: RequestInit = {
    // Could be overridden if necessary
    credentials: "include",
    ...init,
    headers: {
      ...generateClientHeaders(options),
      ...init?.headers,
    },
  }

  return defaultOptions
}
